import { render, staticRenderFns } from "./Bifurcation.vue?vue&type=template&id=8aa8c8ba&scoped=true&"
import script from "./Bifurcation.vue?vue&type=script&lang=js&"
export * from "./Bifurcation.vue?vue&type=script&lang=js&"
import style0 from "./Bifurcation.vue?vue&type=style&index=0&id=8aa8c8ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa8c8ba",
  null
  
)

export default component.exports